import { endpoints } from "@app/api/apis";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import { RootState } from "@app/store/newstore";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import { useIsFocused } from "@react-navigation/native";
import axios from "axios";
import { useEffect, useState } from "react"

export interface BankAndMandateDetails {
    bankAccountDetails: BankAccountDetails
    creditMandateMapping: CreditMandateMapping
    isMandateUpdateAllowed: boolean
}

export interface BankAccountDetails {
    accountNumber: string
    ifscCode: string
    bankName: string
    branchName: string
    branchAddress: any
    bankCode: string
    city: any
    micrCode: any
    beneficiaryName: any
    beneficiaryType: any
    bankFetchSource: any
}

export interface CreditMandateMapping {
    creditId: string
    isMandateSetup: boolean
    umrn: string
    firstCollectionDate: any
    finalCollectionDate: any
    bankName: any
    bankId: any
    maximumMandateAmount: number
    bankAccountNumber: string
    ifsc: string
    createdOn: number
    lastUpdatedOn: number
    id: string
}

export interface UseBankAndMandateDetailsProp {
    data: BankAndMandateDetails,
    isLoading: Boolean
}

export const useBankAndMandate = ():UseBankAndMandateDetailsProp => {
    const [data, setData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);
    const creditId = useAppSelector(
        (state: RootState) => state.auth.userDetails?.linkedCredits?.[0]?.creditId
    );
    const dispatch = useAppDispatch();
    const isFocused = useIsFocused();

    const getData = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `${endpoints.bankAndMandateDetails}${creditId}`
            );
            setData(response.data);
        } catch (error: any) {
            dispatch(showErrorSheet({
                isErrorSheetVisible: true,
                errorMessage: error?.data?.message,
                closeOnBackdropPress: true,
                errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
            }));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if(isFocused && creditId) {
            getData();
        }
    }, [isFocused, creditId]);

    return { data, isLoading };
}


export const useCreditLoanServicingApplication = () => {
    const [AllLoanServicingApplications, setData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);
    const creditId = useAppSelector(
        (state: RootState) => state.auth.userDetails?.linkedCredits?.[0]?.creditId
    );
    const dispatch = useAppDispatch();
    const isFocused = useIsFocused();

    const getData = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `${endpoints.creditLoanServicingApplication}${creditId}`
            );
            setData(response.data);
        } catch (error: any) {
            dispatch(showErrorSheet({
                isErrorSheetVisible: true,
                errorMessage: error?.data?.message,
                closeOnBackdropPress: true,
                errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
            }));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if(isFocused && creditId) {
            getData();
        }
    }, [isFocused, creditId]);

    return { AllLoanServicingApplications, isLoading };
}